import {AmountStatus} from "./race-registration/amount-status";

export class ConfirmPayment {

    constructor(public registrationId?: number, public competitorId?: number, public amountStatus?: AmountStatus, public note?: string) {
    }

}